import checkJs from "../_patterns/00-base/global/utils/check-js";
import initSplash from "../_patterns/02-molecules/splash-screen/splash-screen";
import initBetaBanner from "../_patterns/02-molecules/beta-banner/init-beta-banner";
import observePerformance from "../_patterns/00-base/global/utils/observe-performance";

performance.mark("critical-js-start");

if (checkJs()) {
  window.Modernizr = {};
  observePerformance();
  performance.mark("splash-start");
  initSplash();
  performance.mark("splash-end");
  performance.measure("splash", "splash-start", "splash-end");
  performance.mark("bb-start");
  initBetaBanner();
  performance.mark("bb-end");
  performance.measure("bb", "bb-start", "bb-end");
}
performance.mark("critical-js-end");
performance.measure("critical-js", "critical-js-start", "critical-js-end");